import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import ReviewModal from "./ReviewModal";

const PurchaseHistoryCard = ({ orderItems, orderDate }) => {
    var navigate = useNavigate();
    const [isModalOpen, setModalOpen] = useState(false);
    const [isDownloadPopupOpen, setDownloadPopupOpen] = useState(false);

    const orderStatus = {
        "WAITING": "입금 대기",
        "COMPLETE": "결제 완료",
        "CONFIRM": "구매 확정",
        "CANCEL": "결제 취소",
    }

    // 주문 상태 → 디자인 시스템 뱃지
    const statusBadge = {
        "WAITING": "sc-badge--shipping",
        "COMPLETE": "sc-badge--paid",
        "CONFIRM": "sc-badge--done",
        "CANCEL": "sc-badge--canceled",
    }

    const handleDownloadClick = () => {
        if (orderItems.orderItems.length === 1) {
            window.open(`/software-downloads/${orderItems.orderItems[0].itemId}/index.html`);
        } else {
            setDownloadPopupOpen(true);
        }
    };

    const handleDownloadClickOnPopup = () => {
        // 새창으로 열기
        window.open(`/software-downloads/${orderItems.orderItems[0].itemId}/index.html`, "_blank");
        // 다운로드 팝업 닫기
        setDownloadPopupOpen(false);
    }

    return (
        <div className="purchase-card">
            <div className="purchase-info">
                <div className="product-image-mypage">
                    <img src={orderItems.orderItems[0].thumbnailPath} alt={orderItems.orderItems[0].itemName}/>
                </div>
                <div className="product-details">
                    <span className={`sc-badge ${statusBadge[orderItems.orderStatus] || "sc-badge--done"}`}>{orderStatus[orderItems.orderStatus]}</span>
                    <p className="purchase-date-time">{orderDate} 결제</p>

                    {/* ✅ orderItems.orderItems가 여러 개인 경우 */}
                    {orderItems.orderItems.length > 1 ? (
                        <h4 className="product-title">{orderItems.orderItems[0].itemName} 외 {orderItems.orderItems.length - 1} 개</h4>
                    ) : (
                        // ✅ 한 개일 경우 첫 번째 아이템 표시
                        <h4 className="product-title">{orderItems.orderItems[0].itemName}</h4>
                    )}

                    <p className="product-quantity">{orderItems.orderItems[0].count}개 {orderItems.orderItems[0].subscriptionPeriod}개월</p>
                    <p className="product-price">{orderItems.orderItems[0].orderPrice?.toLocaleString()}원</p>
                    <a href="#" className="order-detail"
                       onClick={() => navigate(`/mypage/purchase/detail/${orderItems.orderId}`)}>주문상세 &gt;</a>
                </div>
            </div>

            {/* 우측 버튼 */}
            <div className="purchase-actions">
                {(orderItems.orderStatus === "COMPLETE" || orderItems.orderStatus === "CONFIRM") ? (
                    <>
                    {orderItems.orderItems.some(item => !item.reviewWriteYn) && (
                        <>
                            <span className="reward-badge">💎 리뷰쓰면 {orderItems.reviewPoint}P 지급!</span>
                            <button className="blue-btn" onClick={() => navigate("/mypage/review-list")}>리뷰쓰기</button>
                        </>
                    )}
                        <button className="white-btn" onClick={handleDownloadClick}>다운받기</button>
                        <button className="white-btn" onClick={() => navigate(`/mypage/subscription`)}>키보기</button>
                    </>
                ) : (
                    ""
                )
                }
            </div>

            {/* 팝업 연결 */}
            {isModalOpen && (
                <ReviewModal
                    onClose={() => setModalOpen(false)}
                    itemId={orderItems.orderItems[0].itemId}
                    orderItemId={orderItems.orderItems[0].orderItemId}
                />
            )}

            {/* 다운로드 팝업 */}
            {isDownloadPopupOpen && (
                <div className="purchase-download-popup">
                    <div className="purchase-popup-content">
                        <h4>다운로드할 상품을 선택하세요</h4>
                        <ul className="purchase-popup-list">
                            {orderItems.orderItems.map((item, idx) => (
                                <li key={idx} onClick={() => handleDownloadClickOnPopup()}>
                                    <span>{item.itemName} ({item.subscriptionPeriod}개월)</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M.5 9.9V12a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V9.9a.5.5 0 0 0-1 0V12a1 1 0 0 1-1 1H2.5a1 1 0 0 1-1-1V9.9a.5.5 0 0 0-1 0z"/>
                                        <path d="M7.646 1.646a.5.5 0 0 1 .708 0l3.5 3.5a.5.5 0 0 1-.708.708L8.5 3.707V10.5a.5.5 0 0 1-1 0V3.707L5.354 5.854a.5.5 0 1 1-.708-.708l3.5-3.5z"/>
                                    </svg>
                                </li>
                            ))}
                        </ul>
                        <button className="purchase-popup-close" onClick={() => setDownloadPopupOpen(false)}>닫기</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PurchaseHistoryCard;
